// extracted by mini-css-extract-plugin
export default {"disableSelection":"styles_disableSelection__KY+mI"};